(() => {
    "use strict";

    angular
        .module("app")
        .filter("stPimsOrderStatus", stPimsOrderStatus);

    function stPimsOrderStatus($filter) {
        return input => {
            switch (input) {
                case "Pending": 
                case "Confirmed":
                case "Assigned for processing": return "Processing";
                case "Pick List Generated": return "Shipping";
                case "Deleted": return "Canceled";
                default: return input;
            }
        };
    }
    stPimsOrderStatus.$inject = ["$filter"];

})()